import { IntelligenceHubMenu } from "@aurem/components";
import { useI18n } from "providers/I18nProvider";
import { useCallback, useEffect, useMemo } from "react";
import ROUTES from "../../const/routes";
import { useAuthorize } from "../../graphql/user";
import { useNavigation } from "../../hooks/navigate";
import { useChatPanel } from "../../root/ChatPanelProvider";
import { PermissionEnum, SortDirection } from "../../types";

export const ChatToggle = () => {
  const canManageAI = useAuthorize(PermissionEnum.ManageAiAssistant);
  const { t } = useI18n();
  const chatCtx = useChatPanel();
  const navigate = useNavigation();

  const navigateToChatHistory = useCallback(() => {
    const search = new URLSearchParams({
      page: "1",
      pageSize: "20",
      sortKey: "lastMessageAt",
      sortOrder: SortDirection.Desc,
      segment: "chats",
    }).toString();
    navigate(`/${ROUTES.CHATS}?${search}`);
  }, [navigate]);

  const toggleNewChat = useCallback(() => {
    chatCtx.triggerNewChat();
  }, [chatCtx]);

  useEffect(() => {
    if (!canManageAI) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      if (!e.ctrlKey) return;

      const key = e.key.toLowerCase();

      if (key === "a") {
        e.preventDefault();
        toggleNewChat();
      } else if (key === "h") {
        e.preventDefault();
        navigateToChatHistory();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [canManageAI, toggleNewChat, navigateToChatHistory]);

  const menuItems = useMemo(() => {
    return [
      {
        id: "new-chat",
        label: t("apps.admin.navBar.chatDropdown.addNewChat"),
        shortcut: "A",
        onClick: toggleNewChat,
      },
      {
        id: "history",
        label: t("apps.admin.navBar.chatDropdown.history"),
        shortcut: "H",
        onClick: navigateToChatHistory,
      },
    ];
  }, [t, toggleNewChat, navigateToChatHistory]);

  if (!canManageAI) {
    return null;
  }

  return <IntelligenceHubMenu menuItems={menuItems} />;
};
